import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Fancybox from '../../components/plugin/fancyox';
import './../../assets/css/pages/resources.css?v=1';
import { handleDownload } from '../../components/button-action/download';
import DOMPurify from 'dompurify';

function ResListComp(props) {

    const getAsset = (path) => {
        try {
            return require(`./../../assets/images/placeholder/${path}`);
        } catch (err) {
            // Fallback to a generic icon if the specific file is missing
            return require('./../../assets/images/oops.png');
        }
    };

    return (
        <div className="resource-item">
        <div className="card">
            <img src={getAsset(`${props.data.file_type}.jpg`)} className="card-img" alt={props.data.title} />
            <div className="card-img-overlay align-content-around text-center">
                <div className="d-flex justify-content-evenly mt-3">
                    {props.data.download_url && (
                        <div className="c-icon">
                            <button 
                                type="button"
                                className={`btn btn-sm btn-facebook ms-2`} 
                                title={`Download ${props.data.title}`}
                                onClick={(e) => handleDownload(e, props.data.download_url, props.data.title)}
                                // disabled={!url}
                            >
                                <i className="mdi mdi-download"></i>
                            </button>
                        </div>
                    )}
                    <div className="c-icon">
                        <Fancybox
                            options={{
                                Carousel: {
                                    infinite: false,
                                },
                                Toolbar: {
                                    display: {
                                        // left: ["infobar"],
                                        // middle: [],
                                        right: ["fullscreen", "zoom", "close"],//slideshow
                                    },
                                },
                            }}
                            className="fancy-box"
                        >
                            <a 
                                data-fancybox="gallery" 
                                data-download-src={props.data.download_url} 
                                // Logic: If it's a ppt/pptx, wrap it in the Office Viewer URL
                                href={
                                    ['ppt', 'pptx'].includes(props.data.file_type) 
                                    ? `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(props.data.view_url)}` 
                                    : props.data.view_url
                                }
                                // Force 'pdf' or 'iframe' for documents to ensure Fancybox doesn't try to render them as images
                                data-type={['ppt', 'pptx', 'doc', 'docx'].includes(props.data.file_type) ? "pdf" : ""} 
                                className="fancybox image gallery-item card btn m-0" 
                                rel="gallery-0"
                                title="View"
                            >
                                <i className="mdi mdi-eye"></i>
                            </a>
                        </Fancybox>
                    </div>
                </div>
            </div>
        </div>
        <div className="details-container">
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>{props.data.title}</Tooltip>}
            >
                <span className="two-line t-title">{props.data.title}</span>
            </OverlayTrigger>

            {props.data?.introduction && (
                <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip>
                        <div
                            dangerouslySetInnerHTML={{ 
                                __html: DOMPurify.sanitize(props.data?.introduction, { ADD_TAGS: ["style"] }) 
                            }}
                        />
                    </Tooltip>}
                >
                    <div className="d-flex text-black-50 pt-1 fs-14">
                    <span className="fw-bold">Introduction:&nbsp;</span>
                    <div
                        className="three-line"

                        dangerouslySetInnerHTML={{ 
                            __html: DOMPurify.sanitize(props.data?.introduction, { ADD_TAGS: ["style"] }) 
                        }}
                    />
                    </div>
                </OverlayTrigger>
            )}

            {props.data?.description && (
                <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip>
                        <div
                            dangerouslySetInnerHTML={{ 
                                __html: DOMPurify.sanitize(props.data?.description, { ADD_TAGS: ["style"] }) 
                            }}
                        />
                    </Tooltip>}
                >
                    <div className="d-flex text-black-50 pt-1 fs-14">
                    <span className="fw-bold">Description:&nbsp;</span>
                    <div
                        className="three-line"

                        dangerouslySetInnerHTML={{ 
                            __html: DOMPurify.sanitize(props.data?.description, { ADD_TAGS: ["style"] }) 
                        }}
                    />
                    </div>
                </OverlayTrigger>
            )}
        </div>
        </div>
    );
}
  
export default ResListComp;